






















































import { computed, defineComponent, PropType, ref } from "@vue/composition-api";
import copy from "clipboard-copy";
import { ceil } from "lodash";
import { ContentPriceSubjectTypeEnum } from "@scrile/api-provider/dist/api/ContentPriceProvider";
import { CryptoInvoice } from "@scrile/api-provider/dist/api/CryptoInvoiceProvider";
import { Currency } from "@scrile/api-provider/dist/api/CurrencyProvider";
import { PaymentPackage } from "@scrile/api-provider/dist/api/PaymentPackageProvider";
import { PaymentSystemPublic } from "@scrile/api-provider/dist/api/PaymentSystemsProvider";
import providers from "@/lib/api";
import { $t } from "@/lib/i18nHelpers";
import { getCost } from "@/lib/moneyHelpers";
import BaseButton from "@/components/BaseButton";
import BaseIcon from "@/components/BaseIcon";
import FormatMoney from "@/components/FormatMoney";
import { systemName } from "./config";

export default defineComponent({
  name: "BitcoinPaymentForm",
  components: { FormatMoney, BaseButton, BaseIcon },
  props: {
    subjectId: { type: String, required: true },
    subjectType: { type: String as PropType<ContentPriceSubjectTypeEnum>, required: true },
    pricePackageId: { type: String, required: true },
    paymentPackages: { type: Array as () => PaymentPackage[], required: true },
    paymentSystemsPublic: { type: Array as () => PaymentSystemPublic[], required: true },
  },
  setup(props) {
    const currencies = ref<Currency[]>([]);
    const processing = ref(false);
    const hasCopiedCost = ref(false);
    const hasCopiedAddress = ref(false);
    const cryptoInvoice = ref<CryptoInvoice | null>(null);
    const cryptoAddress = computed(() => cryptoInvoice.value?.address ?? "");
    const currentPaymentSystemId = computed(
      () => props.paymentSystemsPublic.find(i => i.type === systemName)?.id ?? ""
    );
    const btcRate = computed(() => currencies.value.find(i => i.name === "BTC")?.rate ?? 0);
    const oneTimeCost = computed(() => {
      if (props.pricePackageId === "0") return 0;
      const paymentPackage = props.paymentPackages.find(item => item.id === props.pricePackageId);
      if (!paymentPackage) return 0;
      return getCost(paymentPackage);
    });
    const btcCost = computed(() => ceil(btcRate.value * oneTimeCost.value, 8));

    const onButtonClick = async () => {
      if (!currentPaymentSystemId.value || processing.value) {
        return;
      }
      try {
        processing.value = true;
        cryptoInvoice.value = await providers.CryptoInvoiceProvider.create({
          data: {
            paymentSystemId: currentPaymentSystemId.value,
            subject: { subjectId: props.subjectId, subjectType: props.subjectType },
          },
        });
      } finally {
        processing.value = false;
      }
    };

    const copyCost = async () => {
      await copy($t("{0} BTC", [btcCost.value]));
      hasCopiedCost.value = true;
      setTimeout(() => (hasCopiedCost.value = false), 2000);
    };

    const copyAddress = async () => {
      await copy(cryptoAddress.value);
      hasCopiedAddress.value = true;
      setTimeout(() => (hasCopiedAddress.value = false), 2000);
    };

    const getData = async () => {
      currencies.value = await providers.CurrencyProvider.findAll();
    };

    getData();

    return {
      oneTimeCost,
      btcCost,
      cryptoAddress,
      processing,
      hasCopiedCost,
      hasCopiedAddress,
      copyCost,
      copyAddress,
      onButtonClick,
    };
  },
});
